// userStatusIndicatorConstants.js
'use strict';

export const LIVESTREAM_TYPE_LIVE_BADGE = 'livestream-badge';
export const LIVESTREAM_TYPE_STATUS_BADGE = 'livestream-status-badge';
export const LIVESTREAM_TYPE_DOT = 'livestream-dot';
export const LIVESTREAM_CARD_STATUS_BADGE = 'livestream-card-status-badge';
